import { SpineConst } from "../../../Constants/SpineConst";
import { GameModel } from "../../../Models/GameModel";
import { SpineContainer } from "../../Common/SpineContainer";

const anims = {
    ffx: "ffx"
}

export class VFXMoney extends SpineContainer{
    constructor(model: GameModel, anims = ["ffx"], resource = SpineConst.VFXMoney ){
        super(model, anims, resource);
        this.setAnimation(anims[0], false);
    }
}